





























import {computed, defineComponent, PropType} from "@vue/composition-api"
import {useGetters} from "vuex-composition-helpers"
import Scholarships from "@/apps/StudentExchangeOverviewWidget/components/Scholarships.vue"
import ExchangeRow from "@/apps/StudentExchangeOverviewWidget/components/molecules/ExchangeRow.vue"
import {IExchanges, IExchange} from "@/apps/StudentExchangeOverviewWidget/models/exchanges-viewmodel"
import {ButtonType} from "@/apps/StudentExchangeOverviewWidget/models/shared-viewmodel"

export default defineComponent({
    name: "Exchanges",
    components: {
        ExchangeRow,
        Scholarships,

    },
    props: {
        exchanges: {
            type: Array as PropType<IExchanges>,
            required: true,
            default: () => []
        },
        programOfStudyId: {
            type: Number,
            required: true,
            default: null
        },
        academicYearId: {
            type: String,
            required: true,
            default: null
        },
        groupIndex: {
            type: Number,
            required: true,
            default: 0
        }
    },
    setup: (props) => {
        const {
            getLabels
        } = useGetters([
            'getLabels'
        ])

        const studyExchanges = computed(() => {
            return props.exchanges.filter((exchange: IExchange) => {
                return exchange.groupIndex === props.groupIndex
            })
        })

        function showScholarShipButton(exchange: IExchange) {
            return exchange.showScholarShipButton?.toString() === 'true'
        }

        return {
            getLabels,
            ButtonType,
            studyExchanges,
            showScholarShipButton
        }
    }
})
